module.exports = __webpack_public_path__ + "static/media/404-spaceship.ac0f6e98.svg";